var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 496H16V376H496V496Z",
    fill: "#3498DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 376H16V256H496V376Z",
    fill: "#E32D3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 256H16V136H496V256Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M496 136H16V16H496V136Z",
    fill: "#F1C40F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16L256 256.002L16 496V16Z",
    fill: "#27AE60"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5637 167.663C64.3761 167.663 35.8508 207.214 35.8508 256.002C35.8508 304.79 64.3761 344.341 99.5637 344.341C104.427 344.341 109.171 343.563 113.722 342.132C85.3529 333.201 64.1677 298.039 64.1677 256.002C64.1677 213.965 85.3529 178.802 113.722 169.872C109.171 168.441 104.427 167.663 99.5637 167.663Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.508 187.716H111.081L113.729 176.412L116.377 187.716H124.949L118.015 194.702L120.663 206.006L113.729 199.02L106.795 206.006L109.443 194.702L102.508 187.716V187.716Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.508 229.869H111.081L113.729 218.564L116.377 229.869H124.949L118.015 236.854L120.663 248.158L113.729 241.173L106.795 248.158L109.443 236.854L102.508 229.869V229.869Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.508 272.02H111.081L113.729 260.716L116.377 272.02H124.949L118.015 279.005L120.663 290.309L113.729 283.324L106.795 290.309L109.443 279.005L102.508 272.02V272.02Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M102.508 314.172H111.081L113.729 302.868L116.377 314.172H124.949L118.015 321.158L120.663 332.462L113.729 325.476L106.795 332.462L109.443 321.158L102.508 314.172V314.172Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKm);
export default __webpack_public_path__ + "static/media/KM.05e656c91a712a7b0273c10afbd70e5b.svg";
export { ForwardRef as ReactComponent };